module.exports = __webpack_public_path__ + "static/img/qrcode-ios.054b22c1.png";